const uploadFileToS3 = async (url, file, params = {}) => {
  var body = new FormData();
  Object.keys(params).forEach(key => body.append(key, params[key]));
  body.append('file', file);
  const result = await fetch(url, { method: 'POST', body: body });
  return result;
};

export { uploadFileToS3 };
